export const COMEXSTATS_MODULE_NAME = "comexstats_module";

export const comexstatsModuleMenuItem = {
  icon: "chart-line",
  path: "/comexstats",
};

export const comexstatsModuleRoutes = [
  {
    path: "comexstats",
    name: "ComexStatsReport",
    components: {
      default: () => import("./pages/ComexStatsReport.vue"),
    },
    meta: {
      title: "Comex Stat (MS)",
      requiresAuth: true,
      requiresModule: COMEXSTATS_MODULE_NAME,
    },
  },
];

export default {
  moduleName: COMEXSTATS_MODULE_NAME,
  routes: comexstatsModuleRoutes,
  menuItem: comexstatsModuleMenuItem,
};
